export const SITE_ORIGIN = 'https://hotto.app';

export const STATIC_PAGES = [
  { path: '/', priority: '1.0', changefreq: 'daily' },
];

export const ARTICLE_PAGES = [
  { slug: 'lottery-statistics-2downprize', priority: '0.8', changefreq: 'monthly' },
];

export const PRIORITY_DREAM_KEYWORDS = [
  'งูใหญ่', 'ฝันเห็นพระ', 'น้ำท่วม', 'ฝันเห็นช้าง', 'ฝันเห็นทอง',
  'คนตาย', 'พระ', 'ปลา', 'เด็ก', 'เลือด', 'ช้าง', 'ทอง', 'หนอน',
  'ตัดผม', 'แหวน', 'ปืน', 'งูกัด', 'พญานาค', 'เต่า', 'เสือ',
  'ร้องไห้', 'ตาย', 'รองเท้า', 'งู', 'แมว', 'หมา', 'ไฟไหม้',
  'งูเห่า', 'งูรัด', 'ฝันเห็นงู', 'ฝันเห็นน้ำ', 'ฝันเห็นเงิน',
  'ฝันเห็นคน', 'ฝันเห็นผี', 'ฝันเห็นเลือด',
];

export function dreamSearchUrl(keyword) {
  return `${SITE_ORIGIN}/search/${encodeURIComponent(keyword)}`;
}

export function numberSearchUrl(number) {
  return `${SITE_ORIGIN}/search/${encodeURIComponent(String(number))}`;
}
